import axios from 'axios';
import { API_URLS } from '../config/api';

export const PAYMENT_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  PENDING: 'pending'
};

// Payment configuration
const PAYMENT_CONFIG = {
  SDK_URL: process.env.REACT_APP_NDPS_JS_CDN,
  TIMEOUT: process.env.REACT_APP_API_TIMEOUT,
  RETRY_ATTEMPTS: 3
};

// Simplified payment initiation
export const initiatePayment = async (playerData) => {
  try {
   
    // Prepare payment request with SOCIETY product
    const paymentRequest = {
      playerData: {
        name: playerData.name,
        mobile: playerData.mobile,
        email: playerData.email,
        playerType: playerData.playerType,
        selectedEvent: playerData.selectedEvent,
        age: playerData.age,
        playingStyle: playerData.playingStyle,
        unavailability: playerData.unavailability,
        address: playerData.address,
        remarks: playerData.remarks,
        photoBase64: playerData.photoBase64,  
        regFee : playerData.regFee,        
        cricheroesID: playerData.cricheroesID
      },
      // ✅ ADD THESE NTT Data required fields with SOCIETY:
      product: process.env.REACT_APP_NDPS_PRODUCT || "SOCIETY",        // ← SOCIETY
      prodName: process.env.REACT_APP_NDPS_PROD_NAME || "SOCIETY",    // ← SOCIETY
      amount: playerData.regFee,
      currency: 'INR',
      returnUrl: process.env.REACT_APP_PAYMENT_RETURN_URL,
      cancelUrl: process.env.REACT_APP_PAYMENT_CANCEL_URL,
      transactionId: `TXN_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      description: `Registration fee Rs. ${playerData.regFee} for ${playerData.selectedEvent} - ${ playerData.name}`
    };

    // Initiate payment through backend
    const response = await axios.post(API_URLS.PAYMENT_NEW_INITIATE, paymentRequest, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      timeout: PAYMENT_CONFIG.TIMEOUT
    });

    if (!response.data.success) {
      throw new Error(response.data.error || 'Payment initiation failed');
    }

    // console.log('✅ Payment yet not initiated. now we send AtomTokenId');
    
    // Store player data for registration after payment
    const dataToStore = {
      ...playerData,
      name: response.data.data.name, 
      memberId: response.data.data.memberId,
      merchantTxnId: response.data.data.merchTxnId, 
      atomTokenId: response.data.data.atomTokenId,  

    };
   
       // console.log('merchantTxnId',dataToStore.merchantTxnId);
       // console.log('atomTokenId',dataToStore.atomTokenId)

    // localStorage.setItem('pendingRegistration', JSON.stringify(dataToStore));
    // In paymentHelpers.js line 76
    sessionStorage.setItem('pendingRegistration', JSON.stringify(dataToStore));
    
    // Initialize payment gateway
    return await initializePaymentGateway(response.data.data); //where this is taking 
    
  } catch (error) {
    // console.error('❌ Payment initiation error:', error);
    throw new Error(`Payment failed: ${error.response?.data?.error || error.message || 'Please try again.'}`);
  }
};

// Simplified payment gateway initialization
const initializePaymentGateway = async (paymentData) => {
  return new Promise((resolve, reject) => {
    try {
      const options = {
        atomTokenId: paymentData.atomTokenId,
        merchId: paymentData.merchId,
        custEmail: paymentData.custEmail,
        custMobile: paymentData.custMobile,
        returnUrl: paymentData.returnUrl  //wrie down the https://knkssraipur.com/api/callback/return 
        
      };

      // console.log('🔧 Initializing payment gateway with options:', options);
      
      //let atom = new window.AtomPaynetz(options, 'uat');
      // Load SDK if not already loaded
      if (!window.AtomPaynetz) { // from where you get this
        loadPaymentSDK()
          .then(() => createPaymentInstance(options, resolve, reject))
          .catch(reject);


          // iwant after completing this process we get response from that api or that api send data to here
      } else {
        createPaymentInstance(options, resolve, reject);
      }
      
    } catch (error) {
      reject(new Error(`Payment gateway error: ${error.message}`));
    }
  });
};

// Load payment SDK
const loadPaymentSDK = () => {
  return new Promise((resolve, reject) => {
    // Check if already loading
    const existingScript = document.querySelector('script[src*="atomcheckout.js"]');
    if (existingScript) {
      existingScript.onload = resolve;
      existingScript.onerror = reject;
      return;
    }

    // Prefer backend-provided CDN; else env; else fallback UAT
    const cdn = window.__NDPS_CFG__?.jsCdnUrl
      || process.env.REACT_APP_NDPS_JS_CDN
      || 'https://psa.atomtech.in/staticdata/ots/js/atomcheckout.js';

    // Load new script
    const script = document.createElement('script');
    script.src = cdn;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Failed to load payment gateway'));
    document.head.appendChild(script);
  });
};

// Create payment instance
const createPaymentInstance = (options, resolve, reject) => {
  try {
    // Add small delay to ensure SDK is fully initialized
    setTimeout(() => {
      if (window.AtomPaynetz) {
        //const env = (window.__NDPS_CFG__?.environment || process.env.REACT_APP_NDPS_ENV || 'prod'); // Environment from config or env
        const atom = new window.AtomPaynetz(options, 'uat'); // explain the env here
        // console.log('✅ Payment gateway initialized successfully');
        resolve(atom);
      } else {
        reject(new Error('Payment gateway not available'));
      }
    }, 100);
  } catch (error) {
    reject(new Error(`Payment gateway initialization failed: ${error.message}`));
  }
};

// Simplified payment response processing
export const processPaymentResponse = (searchParams) => {
  const params = Object.fromEntries(searchParams.entries());
  
  // Extract key parameters
  const {
    status,
    txnId,
    atomTxnId,
    bankTxnId,
    amount,
    paymentMode,
    f_code,
    merchantTxnId
  } = params;

  // Determine payment status - ENHANCED with NTT Data status codes
  const isSuccess = /(success|Ok|OTS0000|OTS0551)/i.test(status || f_code || '');
  const isFailed = /(failed|fail|OTS0600|OTS0451|OTS0452|OTS0453|OTS0454|OTS0455|OTS0456|OTS0457|OTS0458|OTS0459|OTS0460)/i.test(status || f_code || '');
  const isCancelled = /(cancel|cancelled|user_cancelled)/i.test(status || f_code || '') || params.encData === 'cancelTransaction';
  const isTimeout = /(timeout|payment_timeout)/i.test(status || f_code || '');
  const isPending = /(pending)/i.test(status || f_code || '');
  
  // Extract transaction data - ENHANCED with all status types
  const transactionData = {
    status: isSuccess ? 'success' : 
            isFailed ? 'failed' : 
            isCancelled ? 'cancelled' : 
            isTimeout ? 'timeout' : 
            isPending ? 'pending' : 'unknown',
    txnId: txnId || atomTxnId || merchantTxnId || 'N/A',
    atomTxnId: atomTxnId || 'N/A',
    bankTxnId: bankTxnId || 'N/A',
    amount: amount || 'N/A',
    paymentMode: paymentMode || 'UPI',
    merchantTxnId: merchantTxnId || txnId || 'N/A',
    timestamp: new Date().toISOString()
  };

  return {
    isSuccess,
    isFailed,
    isCancelled,
    isTimeout,
    isPending,
    transactionData,
    params
  };
};

// Simplified auto-registration after payment
export const registerPlayerAfterPayment = async (playerData, transactionId) => {
  try {
    // console.log('🔄 Auto-registering player after payment:', playerData.name);
    
    const registrationData = {
      ...playerData,
      paymentStatus: PAYMENT_STATUS.SUCCESS,
      transactionId: transactionId,
      registrationDate: new Date().toISOString()
    };

    const response = await axios.post(API_URLS.PLAYER_REGISTER, registrationData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      timeout: PAYMENT_CONFIG.TIMEOUT
    });

    if (response.data.success) {
      // console.log('✅ Player registered successfully after payment');
      return {
        success: true,
        data: response.data,
        player: response.data.player || playerData
      };
    } else {
      throw new Error(response.data.error || 'Registration failed');
    }
    
  } catch (error) {
    // console.error('❌ Auto-registration error:', error);
    throw new Error(`Registration failed: ${error.response?.data?.error || error.message || 'Please contact support.'}`);
  }
};

// Utility function to validate payment response
export const validatePaymentResponse = (params) => {
  const errors = [];
  
  if (!params.txnId && !params.atomTxnId && !params.merchantTxnId) {
    errors.push('Missing transaction ID');
  }
  
  if (!params.status && !params.f_code) {
    errors.push('Missing payment status');
  }
  
  return errors;
};

// Enhanced encrypted response processing
export const processEncryptedResponse = async (encData) => {
  try {
    if (encData === "cancelTransaction") {
      return {
        success: false,
        cancelled: true,
        message: 'Payment cancelled by user'
      };
    }
    
    const response = await axios.post('/api/payment/process-response', {
      encData: encData
    }, {
      timeout: PAYMENT_CONFIG.TIMEOUT
    });
    
    return response.data;
  } catch (error) {
    // console.error('❌ Encrypted response processing error:', error);
    throw new Error('Failed to process encrypted payment response');
  }
};

// Validate payment prerequisites - ADDED FOR REGISTRATION FORM
export const validatePaymentPrerequisites = (data) => {   //Checked
  const errors = [];
  
  if (!data.firstName || !data.firstName.trim()) {
    errors.push('First name is required');
  }
  
  if (!data.lastName || !data.lastName.trim()) {
    errors.push('Last name is required');
  }
  
  if (!data.mobile || data.mobile.length !== 10) {
    errors.push('Valid 10-digit mobile number is required');
  }
  
  if (!/^[6-9]\d{9}$/.test(data.mobile)) {
    errors.push('Please enter a valid Indian mobile number');
  }
  
  if (!data.selectedEvent) {
    errors.push('Please select an event');
  }
  
  if (!data.playerType) {
    errors.push('Please select player type');
  }
  
  if (!data.age || data.age < 1 || data.age > 100) {
    errors.push('Please enter a valid age');
  }
  
  // Child Player age validation
  if (data.playerType === 'Child Player (Kabir Nagar)') {
    if (!data.age || data.age > 16) {
      errors.push('Child Player age must be 16 years or less');
    }
  }
  
  if (!data.address || !data.address.trim()) {
    errors.push('Address is required');
  }
  
  if (!data.playingStyle) {
    errors.push('Please select playing style');
  }
  
  // Photo validation 
  const photoFile = data.photo?.[0] || data.photo;
  if (!photoFile) {
    errors.push('Photo is required');
  } else {
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    
    if (photoFile.size > maxSize) {
      errors.push('Photo size should be less than 5MB');
    }
    
    if (!allowedTypes.includes(photoFile.type)) {
      errors.push('Please upload a valid image file (JPG, PNG, or WebP)');
    }
  }
  
  // Unavailability field - no format validation needed
  
  return errors;
};

// ✅ ADD: New function to get pending registration from database
export const getPendingRegistration = async (merchantTxnId) => {
  try {
    const response = await axios.get(`/api/payment/pending/${merchantTxnId}`, {
      timeout: PAYMENT_CONFIG.TIMEOUT
    });

    if (!response.data.success) {
      throw new Error(response.data.error || 'Pending registration not found');
    }

    return response.data.data;
  } catch (error) {
    // console.error('❌ Failed to retrieve pending registration:', error);
    throw new Error(`Failed to retrieve registration data: ${error.response?.data?.error || error.message}`);
  }
};